/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedAffirm_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarButtons_viewer$ref: FragmentReference;
export type PdpRespSidebarButtons_viewer = {|
  +$fragmentRefs: PdpSharedAffirm_viewer$ref,
  +$refType: PdpRespSidebarButtons_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarButtons_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedAffirm_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '37ed8605ba8febade1ba10f6735a3b70';
module.exports = node;
